import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMService } from "../graphql/mutations";
import {
  UpdateLLMServiceInput,
  UpdateLLMServiceMutation,
} from "../API";

export async function updateLLMServiceAfterEdit(
  values: UpdateLLMServiceInput
): Promise<GraphQLResult<UpdateLLMServiceMutation>> {
  console.log("updateLLMServiceAfterEdit", values);
  return API.graphql(
    graphqlOperation(updateLLMService, {
      input: {
        id: values.id,
        name: values.name,
        status: values.status,
        vendor: values.vendor,
        region: values.region,
        endpoint: values.endpoint,
        body: values.body,
        header: values.header,
        loadProportion: values.loadProportion,
        projectId: values.projectId,
        inputTokenPricePerMillion: values.inputTokenPricePerMillion ? values.inputTokenPricePerMillion as number : undefined,
        outputTokenPricePerMillion: values.outputTokenPricePerMillion ? values.outputTokenPricePerMillion as number : undefined,
        groupId: values.groupId ? values.groupId : "",
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMServiceMutation>>;
}
